import React from 'react'
import { DictionaryText, DictionaryTextProps } from '../../../atoms/Dictionary/DictionaryText'
import { ValidationError } from 'yup'

// TODO: fix this missing keyword in story OPGAVES-2082
// eslint-disable-next-line
type unkown = any

/**
 * @memberof ValidationMessages
 * */
export const constructMessage = (error: ValidationError) => {
    const isObject = typeof error.message === 'object'
    const isString = typeof error.message === 'string'
    const isArray = Array.isArray(error.message)

    switch (true) {
        case isString:
            return <DictionaryText textKey={error.message} />
        case isArray:
            return (
                <>
                    {(error.message as unkown as string[]).map((error) => (
                        <DictionaryText textKey={error} />
                    ))}
                </>
            )
        case isObject: {
            const messageRecord: Record<string, DictionaryTextProps> = error.message as unkown
            const messageObject = messageRecord[Object.keys(messageRecord)[0]]
            const { textKey, replacer } = messageObject

            return <DictionaryText textKey={textKey ?? ''} replacer={replacer} />
        }
        default:
            return <DictionaryText textKey={error.message} />
    }
}
